import { render, staticRenderFns } from "./CompetitionStatsGenerator.component.vue?vue&type=template&id=56eb5a08&scoped=true"
import script from "./CompetitionStatsGenerator.component.vue?vue&type=script&lang=ts"
export * from "./CompetitionStatsGenerator.component.vue?vue&type=script&lang=ts"
import style0 from "./CompetitionStatsGenerator.component.vue?vue&type=style&index=0&id=56eb5a08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.44_cache-loader@4.1.0_webpack@4.47.0__css-load_9104b087796de0a589f26e8ae34b49bc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56eb5a08",
  null
  
)

export default component.exports